/*
 * @Author: Fan
 * @Date: 2020-04-18 21:23:13
 * @description:
 * @LastEditors: Fu Zhuohang
 */
import { DataType } from "../../../typings";
import { inputControlOptions, } from "../../../component-schema";
import i18n from "../../../i18n";
export default {
    $id: "address",
    type: DataType.Object,
    $ref: inputControlOptions.$id,
    properties: {
        widgetType: {
            type: DataType.Number,
            title: i18n.t('dataitem.ControlType').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        locationType: {
            type: DataType.String,
            title: i18n.t('dataitem.AddressFormat').toString(),
            default: 'pp-cc-aa'
        },
        addressDetail: {
            type: DataType.String,
            title: i18n.t('dataitem.AddressDetail').toString(),
            default: "true",
        },
        showEmpty: {
            type: DataType.String,
            title: i18n.t('dataitem.DisplayEmpty').toString(),
            default: "false",
        },
        emptyValue: {
            type: DataType.String,
            title: i18n.t('dataitem.EmptyValue').toString(),
            default: i18n.t('dataitem.SelectPlaceholder').toString(),
        },
        autoGetLocation: {
            type: DataType.String,
            title: i18n.t('dataitem.AutoLocation').toString(),
            default: "false",
        },
        dataLinkage: {
            type: DataType.String,
            title: i18n.t('dataitem.DataLinkage').toString(),
        },
        defaultValue: {
            type: DataType.Object,
            title: i18n.t('dataitem.DefaultValue').toString(),
        },
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
        readonlyCondition: {
            type: DataType.String,
            title: i18n.t('dataitem.ReadonlyConditions').toString(),
        },
    },
};
